/* eslint-disable max-len */
import Fetch, { V1 } from 'Util/fetcher';
import { ON_PRICE_SOCKET_CHANGE } from './tradeSocket';


const ON_REQUEST_PRICE_FROM_WATCHLIST = 'ON_REQUEST_PRICE_FROM_WATCHLIST';


// WATCHLIST PRICE SOCKET
export function onRequestPriceFromWatchlist(payload, code) {
  return {
    type: ON_REQUEST_PRICE_FROM_WATCHLIST,
    payload,
    meta: { code },
  };
}

//= ==================================================================================================================//
//                                           SHOW PRICE STOCK                                                 //
//= =================================================================================

const ON_REQUEST_PRICE_STOCK = 'ON_REQUEST_PRICE_STOCK';
const ON_REQUEST_PRICE_STOCK_FAILURE = 'ON_REQUEST_PRICE_STOCK_FAILURE';
const ON_REQUEST_PRICE_STOCK_SUCCESS = 'ON_REQUEST_PRICE_STOCK_SUCCESS';

function onRequestPriceStock(code) {
  return {
    type: ON_REQUEST_PRICE_STOCK,
    meta: { code },
  };
}

export function onRequestPriceStockSuccess(payload, code) {
  return {
    type: ON_REQUEST_PRICE_STOCK_SUCCESS,
    payload,
    meta: { code },
  };
}

function onRequestPriceStockFailure(payload, code) {
  return {
    type: ON_REQUEST_PRICE_STOCK_FAILURE,
    payload,
    meta: { code },
  };
}

export const onDoRequestPriceStock = payload => (dispatch) => {
  dispatch(onRequestPriceStock(payload));
  Fetch.get(`${V1}stock/detail/${payload}/price/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestPriceStockSuccess(resp.json, payload));
      } else {
        dispatch(onRequestPriceStockFailure(resp.json, payload));
      }
    })
    .catch((error) => {
      dispatch(onRequestPriceStockFailure(error.message, payload));
    });
};

const ON_REQUEST_PRICE_DETAIL_STOCK = 'ON_REQUEST_PRICE_DETAIL_STOCK';
const ON_REQUEST_PRICE__DETAIL_STOCK_FAILURE = 'ON_REQUEST_PRICE__DETAIL_STOCK_FAILURE';
const ON_REQUEST_PRICE_DETAIL_STOCK_SUCCESS = 'ON_REQUEST_PRICE_DETAIL_STOCK_SUCCESS';

function onRequestPriceDetail() {
  return {
    type: ON_REQUEST_PRICE_DETAIL_STOCK,
  };
}

function onRequestPriceDetailSuccess(payload) {
  return {
    type: ON_REQUEST_PRICE_DETAIL_STOCK_SUCCESS,
    payload,
  };
}

function onRequestPriceDetailFailure(payload) {
  return {
    type: ON_REQUEST_PRICE__DETAIL_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestPriceDetail = payload => (dispatch) => {
  dispatch(onRequestPriceDetail());
  Fetch.get(`${V1}stock/detail/${payload}/price/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestPriceDetailSuccess(resp.json));
      } else {
        dispatch(onRequestPriceDetailFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestPriceDetailFailure(error.message));
    });
};

//= ==================================================================================================================//
//                                           SHOW STOCK INFORMATION                                                 //
//= =================================================================================

const ON_REQUEST_ABOUT_STOCK = 'ON_REQUEST_ABOUT_STOCK';
const ON_REQUEST_ABOUT_STOCK_FAILURE = 'ON_REQUEST_ABOUT_STOCK_FAILURE';
const ON_REQUEST_ABOUT_STOCK_SUCCESS = 'ON_REQUEST_ABOUT_STOCK_SUCCESS';

function onRequestAboutStock() {
  return {
    type: ON_REQUEST_ABOUT_STOCK,
  };
}

function onRequestAboutStockSuccess(payload) {
  return {
    type: ON_REQUEST_ABOUT_STOCK_SUCCESS,
    payload,
  };
}

function onRequestAboutStockFailure(payload) {
  return {
    type: ON_REQUEST_ABOUT_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestAboutStock = payload => (dispatch) => {
  dispatch(onRequestAboutStock());
  Fetch.get(`${V1}stock/detail/${payload}/about/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestAboutStockSuccess(resp.json));
      } else {
        dispatch(onRequestAboutStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestAboutStockFailure(error.message));
    });
};

//= ==================================================================================================================//
//                                           SHOW PRICE ORDER BOOK                                                   //
//= ==================================================================================================================//

const ON_REQUEST_PRICE_ODER_BOOK_STOCK = 'ON_REQUEST_PRICE_ODER_BOOK_STOCK';
const ON_REQUEST_PRICE_ODER_BOOK_STOCK_SUCCESS = 'ON_REQUEST_PRICE_ODER_BOOK_STOCK_SUCCESS';
const ON_REQUEST_PRICE_ODER_BOOK_STOCK_FAILURE = 'ON_REQUEST_PRICE_ODER_BOOK_STOCK_FAILURE';

function onRequestPriceOrderBookStock(code) {
  return {
    type: ON_REQUEST_PRICE_ODER_BOOK_STOCK,
    meta: { code },
  };
}

function onRequestPriceOrderBookStockSuccess(payload, code) {
  return {
    type: ON_REQUEST_PRICE_ODER_BOOK_STOCK_SUCCESS,
    payload,
    meta: { code },
  };
}

function onRequestPriceOrderBookFailure(payload, code) {
  return {
    type: ON_REQUEST_PRICE_ODER_BOOK_STOCK_FAILURE,
    payload,
    meta: { code },
  };
}

export const onDoRequestPriceOrderBookStock = payload => (dispatch) => {
  dispatch(onRequestPriceOrderBookStock(payload));
  Fetch.get(`${V1}stock/bestquote/?code=${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestPriceOrderBookStockSuccess(resp.json, payload));
      } else {
        dispatch(onRequestPriceOrderBookFailure(resp.json, payload));
      }
    })
    .catch((error) => {
      dispatch(onRequestPriceOrderBookFailure(error.message));
    });
};

//= ==================================================================================================================//
//                                           GET TRADING STATISTIC                                                   //
//= ==================================================================================================================//

const ON_REQUEST_TRADING_STAT_DETAIL_STOCK = 'ON_REQUEST_TRADING_STAT_DETAIL_STOCK';
const ON_REQUEST_TRADING_STAT_DETAIL_STOCK_FAILURE = 'ON_REQUEST_TRADING_STAT_DETAIL_STOCK_FAILURE';
const ON_REQUEST_TRADING_STAT_DETAIL_STOCK_SUCCESS = 'ON_REQUEST_TRADING_STAT_DETAIL_STOCK_SUCCESS';

function onRequestTradingStatDetailStock(code) {
  return {
    type: ON_REQUEST_TRADING_STAT_DETAIL_STOCK,
    meta: { code },
  };
}

function onRequestTradingStatStockDetailSuccess(payload, code) {
  return {
    type: ON_REQUEST_TRADING_STAT_DETAIL_STOCK_SUCCESS,
    payload,
    meta: { code },
  };
}

function onRequestTadingStatStockDetailFailure(payload, code) {
  return {
    type: ON_REQUEST_TRADING_STAT_DETAIL_STOCK_FAILURE,
    payload,
    meta: { code },
  };
}

export const onDoRequestTradingStatDetailStock = payload => (dispatch) => {
  dispatch(onRequestTradingStatDetailStock(payload));
  Fetch.get(`${V1}stock/detail/${payload}/trading_statistics/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestTradingStatStockDetailSuccess(resp.json, payload));
      } else {
        dispatch(onRequestTadingStatStockDetailFailure(resp.json, payload));
      }
    })
    .catch((error) => {
      dispatch(onRequestTadingStatStockDetailFailure(error.message, payload));
    });
};

//= ==================================================================================================================//
//                                           GET KEY STATISTIC                                                   //
//= ==================================================================================================================//

const ON_REQUEST_KEY_STAT_DETAIL_STOCK = 'ON_REQUEST_KEY_STAT_DETAIL_STOCK';
const ON_REQUEST_KEY_STAT_DETAIL_STOCK_SUCCESS = 'ON_REQUEST_KEY_STAT_DETAIL_STOCK_SUCCESS';
const ON_REQUEST_KEY_STAT_DETAIL_STOCK_FAILURE = 'ON_REQUEST_KEY_STAT_DETAIL_STOCK_FAILURE';

function onRequestKeyStatDetailStock() {
  return {
    type: ON_REQUEST_KEY_STAT_DETAIL_STOCK,
  };
}

function onRequestKeyStatStockDetailSuccess(payload) {
  return {
    type: ON_REQUEST_KEY_STAT_DETAIL_STOCK_SUCCESS,
    payload,
  };
}

function onRequestKeyStatStockDetailFailure(payload) {
  return {
    type: ON_REQUEST_KEY_STAT_DETAIL_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestKeyStatDetailStock = payload => (dispatch) => {
  dispatch(onRequestKeyStatDetailStock());
  Fetch.get(`${V1}stock/detail/${payload}/key_statistics/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestKeyStatStockDetailSuccess(resp.json));
      } else {
        dispatch(onRequestKeyStatStockDetailFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestKeyStatStockDetailFailure(error.message));
    });
};

//= ==================================================================================================================//
//                                                       BROKER SUMMARY                                                //
//= ==================================================================================================================//

const ON_REQUEST_BROKER_SUMMARY = 'ON_REQUEST_BROKER_SUMMARY';
const ON_REQUEST_BROKER_SUMMARY_FAILURE = 'ON_REQUEST_BROKER_SUMMARY_FAILURE';
const ON_REQUEST_BROKER_SUMMARY_SUCCESS = 'ON_REQUEST_BROKER_SUMMARY_SUCCESS';

function onRequestBrokerSummary() {
  return {
    type: ON_REQUEST_BROKER_SUMMARY,
  };
}

function onRequestBrokerSummarySuccess(payload) {
  return {
    type: ON_REQUEST_BROKER_SUMMARY_SUCCESS,
    payload,
  };
}

function onRequestBrokerSummaryFailure(payload) {
  return {
    type: ON_REQUEST_BROKER_SUMMARY_FAILURE,
    payload,
  };
}

export const onDoRequestBrokerSummary = (code, payload) => (dispatch) => {
  dispatch(onRequestBrokerSummary());
  Fetch.get(`${V1}stock/data/broker/summary/${code}/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestBrokerSummarySuccess(resp.json));
      } else {
        dispatch(onRequestBrokerSummaryFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestBrokerSummaryFailure(error.message));
    });
};

//= ==================================================================================================================//
//                                                       BROKER PROFILE                                                //
//= ==================================================================================================================//

const ON_REQUEST_BROKER_PROFILE = 'ON_REQUEST_BROKER_PROFILE';
const ON_REQUEST_BROKER_PROFILE_FAILURE = 'ON_REQUEST_BROKER_PROFILE_FAILURE';
const ON_REQUEST_BROKER_PROFILE_SUCCESS = 'ON_REQUEST_BROKER_PROFILE_SUCCESS';

function onRequestBrokerProfile() {
  return {
    type: ON_REQUEST_BROKER_PROFILE,
  };
}

function onRequestBrokerProfileSuccess(payload) {
  return {
    type: ON_REQUEST_BROKER_PROFILE_SUCCESS,
    payload,
  };
}

function onRequestBrokerProfileFailure(payload) {
  return {
    type: ON_REQUEST_BROKER_PROFILE_FAILURE,
    payload,
  };
}

export const onDoRequestBrokerProfile = () => (dispatch) => {
  dispatch(onRequestBrokerProfile());
  Fetch.get(`${V1}stock/data/broker/profile/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestBrokerProfileSuccess(resp.json));
      } else {
        dispatch(onRequestBrokerProfileFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestBrokerProfileFailure(error.message));
    });
};

const INITIAL_STATE = {
  priceStockData: null,
  priceStockLoading: null,
  priceStockError: null,
  aboutStockData: null,
  aboutStockLoading: null,
  aboutStockError: null,
  orderBookData: null,
  orderBookLoading: null,
  orderBookError: null,
  tradingStatDetailStockLoading: null,
  tradingStatDetailStockData: null,
  tradingStatDetailStockError: null,
  priceDetailData: null,
  priceDetailLoading: null,
  priceDetailError: null,
  keyStatDetailStockLoading: false,
  keyStatDetailStockData: null,
  keyStatDetailStockError: null,

  brokerProfileLoading: null,
  brokerProfileData: null,
  brokerProfileError: null,

  brokerSummaryLoading: null,
  brokerSummaryData: null,
  brokerSummaryError: null,
};

const detailStock = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_PRICE_STOCK:
      return {
        ...state,
        priceStockLoading: {
          ...state.priceStockLoading,
          [action.meta.code]: true,
        },
        priceStockError: {
          ...state.priceStockError,
          [action.meta.code]: null,
        },
      };
    case ON_REQUEST_PRICE_STOCK_SUCCESS:
      return {
        ...state,
        priceStockLoading: {
          ...state.priceStockLoading,
          [action.meta.code]: false,
        },
        priceStockData: {
          ...state.priceStockData,
          [action.meta.code]: action.payload,
        },
        priceStockError: {
          ...state.priceStockError,
          [action.meta.code]: null,
        },
      };
    case ON_REQUEST_PRICE_STOCK_FAILURE:
      return {
        ...state,
        priceStockLoading: {
          ...state.priceStockLoading,
          [action.meta.code]: false,
        },
        priceStockError: {
          ...state.priceStockError,
          [action.meta.code]: action.payload,
        },
      };

    case ON_REQUEST_ABOUT_STOCK:
      return {
        ...state,
        aboutStockLoading: true,
        aboutStockData: null,
        aboutStockError: null,
      };
    case ON_REQUEST_ABOUT_STOCK_SUCCESS:
      return {
        ...state,
        aboutStockLoading: false,
        aboutStockData: action.payload,
        aboutStockError: null,
      };
    case ON_REQUEST_ABOUT_STOCK_FAILURE:
      return {
        ...state,
        aboutStockLoading: false,
        aboutStockData: null,
        aboutStockError: action.payload,
      };

    case ON_PRICE_SOCKET_CHANGE:
      if (state.priceStockData) {
        let tempState = state;
        const datum = action.payload;
        if (!datum.ticker) return state;
        // check if current change datum.ticker is the same with current priceStockData.
        Object.keys(state.priceStockData).forEach((stockCode) => {
          if (datum.ticker === stockCode) {
            tempState = {
              ...state,
              priceStockData: {
                ...state.priceStockData,
                [datum.ticker]: {
                  ...state.priceStockData[datum.ticker],
                  old_price: state.priceStockData[datum.ticker].price,
                  price: datum.price,
                  return_amount: datum.change,
                  return_pct: datum.pctChange,
                },
              },
            };
          }
        });

        return tempState;
      }
      return state;
      
    case ON_REQUEST_PRICE_FROM_WATCHLIST:
        return {
          ...state,
          priceStockData: {
            ...state.priceStockData,
            [action.meta.code]: {
              price: action.payload?.price,
              return_amount: action.payload?.change,
              return_pct: action.payload?.change_pct,
            },
          },
        };  

    case ON_REQUEST_PRICE_DETAIL_STOCK:
      return {
        ...state,
        priceDetailLoading: true,
        priceDetailData: null,
        priceDetailError: null,
      };
    case ON_REQUEST_PRICE_DETAIL_STOCK_SUCCESS:
      return {
        ...state,
        priceDetailLoading: false,
        priceDetailData: action.payload,
        priceDetailError: null,
      };
    case ON_REQUEST_PRICE__DETAIL_STOCK_FAILURE:
      return {
        ...state,
        priceDetailLoading: false,
        priceDetailData: null,
        priceDetailError: action.payload,
      };

    case ON_REQUEST_PRICE_ODER_BOOK_STOCK:
      return {
        ...state,
        orderBookLoading: {
          ...state.orderBookLoading,
          [action.meta.code]: true,
        },
        orderBookError: {
          ...state.orderBookError,
          [action.meta.code]: null,
        },
      };
    case ON_REQUEST_PRICE_ODER_BOOK_STOCK_SUCCESS:
      return {
        ...state,
        orderBookLoading: {
          ...state.orderBookLoading,
          [action.meta.code]: false,
        },
        orderBookData: {
          ...state.orderBookData,
          [action.meta.code]: action.payload,
        },
        orderBookError: {
          ...state.orderBookError,
          [action.meta.code]: null,
        },
      };
    case ON_REQUEST_PRICE_ODER_BOOK_STOCK_FAILURE:
      return {
        ...state,
        orderBookLoading: {
          ...state.orderBookLoading,
          [action.meta.code]: false,
        },
        orderBookError: {
          ...state.orderBookError,
          [action.meta.code]: action.payload,
        },
      };
    case ON_REQUEST_TRADING_STAT_DETAIL_STOCK:
      return {
        ...state,
        tradingStatDetailStockLoading: {
          ...state.tradingStatDetailStockLoading,
          [action.meta.code]: true,
        },
        tradingStatDetailStockError: {
          ...state.tradingStatDetailStockError,
          [action.meta.code]: null,
        },
      };
    case ON_REQUEST_TRADING_STAT_DETAIL_STOCK_SUCCESS:
      return {
        ...state,
        tradingStatDetailStockLoading: {
          ...state.tradingStatDetailStockLoading,
          [action.meta.code]: false,
        },
        tradingStatDetailStockData: {
          ...state.tradingStatDetailStockData,
          [action.meta.code]: action.payload,
        },
        tradingStatDetailStockError: {
          ...state.tradingStatDetailStockError,
          [action.meta.code]: null,
        },
      };
    case ON_REQUEST_TRADING_STAT_DETAIL_STOCK_FAILURE:
      return {
        ...state,
        tradingStatDetailStockLoading: {
          ...state.tradingStatDetailStockLoading,
          [action.meta.code]: false,
        },
        tradingStatDetailStockError: {
          ...state.tradingStatDetailStockError,
          [action.meta.code]: action.payload,
        },
      };
    case 'ON_REQUEST_BROKER_SUMMARY':
      return {
        ...state,
        brokerSummaryLoading: true,
        brokerSummaryData: null,
        brokerSummaryError: null,
      };
    case 'ON_REQUEST_BROKER_SUMMARY_SUCCESS':
      return {
        ...state,
        brokerSummaryLoading: false,
        brokerSummaryData: action.payload.result,
        brokerSummaryError: null,
      };
    case 'ON_REQUEST_BROKER_SUMMARY_FAILURE':
      return {
        ...state,
        brokerSummaryLoading: false,
        brokerSummaryData: null,
        brokerSummaryError: action.payload,
      };
    case 'ON_REQUEST_BROKER_PROFILE':
      return {
        ...state,
        brokerProfileLoading: true,
        brokerProfileData: null,
        brokerProfileError: null,
      };
    case 'ON_REQUEST_BROKER_PROFILE_SUCCESS':
      return {
        ...state,
        brokerProfileLoading: false,
        brokerProfileData: action.payload.results,
        brokerProfileError: null,
      };
    case 'ON_REQUEST_BROKER_PROFILE_FAILURE':
      return {
        ...state,
        brokerProfileLoading: false,
        brokerProfileData: null,
        brokerProfileError: action.payload,
      };
    default:
      return state;
  }
};

export default detailStock;
